import React, { useState, useEffect, useContext } from "react";

import { apiGet } from "app/Services/ApiService";
import { apiUrls } from 'common/ApiUrls';
import { PrivateRoutesContext } from "app/PrivateRoutesContext";

import MessageCarousel from "components/MessageCarousel";

export default function Messages () {
  const { companyId } = useContext(PrivateRoutesContext);

  const [messages, setMessages] = useState([]);
  const [hasInitializationError, setHasInitializationError] = useState(false);

  useEffect(() => {
    handleChangeCompany()
  }, [companyId]);

  const handleChangeCompany = () => {
    apiGet(apiUrls.getMessages(companyId)).then(
      (response) => {
        setMessages(response.data);
        setHasInitializationError(false);
      }
    )
    .catch((response) => {
      setHasInitializationError(true);
    });
  }

  return (
    <MessageCarousel messages={messages} hasInitializationError={hasInitializationError} />
  );
}
